<div class="dashboard-container">
  <div *ngIf="isLoading" class="loading-container">Loading...</div>

  <div *ngIf="reportNotFound" class="no-report-container">
    Report view not available
  </div>

  <div
    *ngIf="!reportNotFound && hasMultipleDashboards"
    class="dashboard-selector mb-3">
    <label for="dashboardSelect" class="form-label">Select Dashboard:</label>
    <select
      id="dashboardSelect"
      class="form-select"
      [ngModel]="selectedDashboardId"
      (ngModelChange)="onDashboardChange($event)">
      <option
        *ngFor="let dashboard of dashboardOptions"
        [value]="dashboard.dashboardId">
        {{ dashboard.name }}
        <span *ngIf="dashboard.isDefault"> (Default)</span>
      </option>
    </select>
  </div>

  <iframe
    *ngIf="metabaseUrl && !reportNotFound"
    [src]="metabaseUrl"
    frameborder="0"
    width="100%"
    height="800px"
    allowtransparency
    title="IremboGov Report"
    class="metabase-iframe">
  </iframe>
</div>
